var _jsxFileName = "/repo/packages/webassets/src/components/SurveyTheme/SurveyTheme.tsx",
  _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { useQuery } from '@apollo/client';
import { SurveyThemeProvider } from './context';
import { formatTheme } from './helpers';
import getSurveyDesign from './SurveyTheme.graphql';
/** A simple wrapper composes inner children with the fetched theming info. */
var SurveyTheme = function SurveyTheme(_ref) {
  var children = _ref.children,
    surveyId = _ref.surveyId,
    targetEndPoint = _ref.targetEndPoint,
    headers = _ref.headers;
  var _useQuery = useQuery(getSurveyDesign, {
      variables: _objectSpread({
        id: surveyId,
        errorPolicy: 'all',
        partialRefetch: true
      }, targetEndPoint && {
        context: _objectSpread({
          targetPath: "/lo-graphql/".concat(targetEndPoint)
        }, headers && headers)
      })
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    fetchError = _useQuery.error,
    refetch = _useQuery.refetch;

  /* No-op on the loading state.
   * The wrapping component should know better how to compose with a representable skeleton.
   */
  if (loading) {
    return null;
  }
  var surveyTheme = formatTheme(data);
  return /*#__PURE__*/React.createElement(SurveyThemeProvider, {
    theme: _objectSpread(_objectSpread({}, surveyTheme), fetchError && {
      refetch: refetch,
      fetchError: fetchError
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, children);
};
export default SurveyTheme;
//# sourceMappingURL=SurveyTheme.js.map